import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../../context/userContext';
import ConfirmationModal from '../../../components/modal/ConfirmationModal';
import { formatPrice, getLocalizationStatus } from '../../../utils/HelperFuncitons';
import moment from 'moment';
import StatusModal from '../../../components/modal/StatusModal';
import { approveOrRejectBillingSummaryByIdApi, getSiteBillSummaryApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import ActivityHistory from '../../../components/common/ActivityHistory';

function ViewFinalBill() {
   const { userDetails, langPreference } = useUserContext();
   const [searchParams, setSearchParams] = useSearchParams()
   const [details,setDetails] = useState(null)
   const [loading,setLoading] = useState(true)
   const {id} = useParams()
   const navigate = useNavigate();
   const confirmModalId = "conFirmModalID"
   const statusModalId = "statusModal"
   const [confirmationMsg, setConfirmationMsg] = useState('')
   const [updatedStatus, setUpdatedStatus] = useState(null)

   const handleApproval = async () => {
      try {
         const res = await approveOrRejectBillingSummaryByIdApi({ id: details?._id, status: updatedStatus })
         if (res.status === 200) {
            toast.success(res.data?.message)
            document.getElementById(confirmModalId).click()
            setConfirmationMsg(res?.data?.message || `Billing summary ${details?.billSummaryNumber || ""} is successfully ${updatedStatus}.`)
            document.getElementById("statusModalBtn").click()
         }
      } catch (error) {
         console.log(error)
         if (error && error?.response?.data?.message) {
            toast.error(error?.response?.data?.message);
         } else {
            toast.error("something went wrong");
         }
      }
   }

   const handleCloseStatusModal = () => {
      getBillingSummaryDetails()
   }

   const getBillingSummaryDetails = async () => {
      setLoading(true)
      try {
        let billType = searchParams?.get("tab")
        const { data } = await getSiteBillSummaryApi(id,billType)
        if (data?.data[0]) {
          setDetails(data?.data[0])
        }
        setLoading(false)
      } catch (error) {
        console.log("handleGenerateSummary error", error);
        error && error.response ?
          toast.error(error.response?.data?.message) :
          toast.error("something went wrong");
      }
    }
  
    useEffect(() => {
      if(id){
        getBillingSummaryDetails()
      }
    }, [searchParams?.get("tab")])

   return (
      <>
         <div className="main-content">
            <div className="container-fluid">
               <div className="row">
                  <div className="back"><span onClick={() => navigate(`/billing?tab=${searchParams?.get('tab')}&type=final-bill`)} className="back cursor-pointer" ><i className="bi bi-chevron-left"></i> {langPreference?.back || "Back"}</span></div>
                  <div className="main-content">

                     <div className="row d-flex justify-content-center">
                        <div className="card col-lg-10 col-md-12 col-xxl-11 my-3 p-5">

                           <div className="">
                              <div className='fs-3 fw-normal'>
                                 {langPreference?.site_details || "Site details"}
                              </div>
                              <div className="row row-cols-2">
                                 <div className="">{langPreference?.site_name || "Site name"}</div>
                                 <div>{details?.site?.[0]?.name}</div>
                              </div>
                              <div className="row row-cols-2">
                                 <div className="">{langPreference?.site_address || "Site address"}</div>
                                 <div>{details?.site?.[0]?.addressId?.address1}</div>
                              </div>
                           </div>
                           <hr />
                           <div>
                              <div className="row row-cols-2 mt-3">
                                 <div className="fw-bold">{langPreference?.billing_number || "Billing Number"}</div>
                                 <div>{details?.billSummaryNumber}</div>
                              </div>
                              <div className="row row-cols-2 mt-3">
                                 <div className="fw-bold">{langPreference?.bill_date || "Bill Date"}</div>
                                 <div>{moment(details?.billDate).format("DD/MM/YYYY")}</div>
                              </div>
                              <div className="row row-cols-2 mt-3">
                                 <div className="fw-bold">{langPreference?.ra_bill_no || "RA Bill No"}</div>
                                 <div>{details?.raBillNo}</div>
                              </div>

                              <div className="row row-cols-2 mt-3">
                                 <div className="fw-bold">{langPreference.status || "Status"}</div>
                                 <div className='text-capitalize'>{getLocalizationStatus(langPreference, details?.status)}</div>
                              </div>
                           </div>
                           <hr />
                           <h3>
                              {langPreference?.items || "Items"} ({details?.items?.length || 0})
                           </h3>
                           <div className='table-responsive'>
                              <table className="table table-responsive">
                                 <thead>
                                    <tr>
                                       <th>{langPreference?.boq_no || "Boq No"}</th>
                                       <th style={{ maxWidth: 250 }}>{langPreference?.boq_item_description || "Boq item description"}</th>
                                       <th><div className='d-flex justify-content-end'>{langPreference?.rate || "Rate"}</div></th>
                                       <th><div className='d-flex justify-content-end'>{langPreference?.total_quantity || "Qty"}</div></th>
                                       <th><div className='d-flex justify-content-end'>{langPreference?.withhold_quantity || "with hold Qty"}</div></th>
                                       <th><div className='d-flex justify-content-end'>{langPreference?.net_quantity || "Net Quantity"}</div></th>
                                       <th><div className='d-flex justify-content-end'>{langPreference?.net_amount || "Net Amount"}</div></th>
                                    </tr>
                                 </thead>
                                 <tbody >
                                    {details?.items?.map((ele, index) => {
                                       return (
                                          <tr key={index}>
                                             <td>{ele?.sNo}</td>
                                             <td style={{ overflowWrap: "anywhere", maxWidth: 350 }}>{ele?.nameAndDetails}</td>
                                             <td><div className='d-flex justify-content-end'>{ele?.unitPrice}</div></td>
                                             <td><div className='d-flex justify-content-end'>{ele?.quantity}</div></td>
                                             <td><div className='d-flex justify-content-end'>{ele?.withHoldQty}</div></td>
                                             <td><div className='d-flex justify-content-end'> {ele?.netQty}</div></td>
                                             <td className=''> <div className='d-flex justify-content-end'>{formatPrice(ele?.netAmt || 0)}</div></td>
                                          </tr>
                                       )
                                    })}
                                 </tbody>
                              </table>
                           </div>
                           <hr />
                           <div className='amount-box p-2 px-3'>
                              <div className="d-flex total justify-content-between align-items-center">
                                 <p>{langPreference?.total_quantity || "Total quantity"}</p>
                                 <p>{details?.netQty}</p>
                              </div>
                              <div className="d-flex total justify-content-between align-items-center">
                                 <p>{langPreference?.total_amount || "Total amount"}</p>
                                 <p>{formatPrice(details?.netAmt)}</p>
                              </div>

                           </div>
                           <hr />
                           <ActivityHistory data={details} language={langPreference} />
                           <hr />


                           <div className="d-flex justify-contend-start gap-2">

                              {details?.status !== "created" && details?.status !== "approved" && details?.status !== "rejected" && userDetails?.roleId?.permission.includes("approveFinalBill") && <div className="d-flex justify-content-between gap-2 mt-3">
                                 <div className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => setUpdatedStatus("approved")}>{langPreference?.approve || "Approve"}</div>
                              </div>}
                              {userDetails?.roleId?.permission.includes("updateFinalBill") && details?.status?.toLowerCase() !== "approved" && <div className="d-flex justify-content-between gap-2 mt-3"> <button className='btn btn-primary' onClick={() => { setSearchParams({ tab: searchParams.get('tab') }) }} > {langPreference?.edit || "Edit"}</button></div>}
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
         </div>
         <ConfirmationModal modalId={confirmModalId} handleConfirm={handleApproval} message={langPreference?.approve_confirmation || <>Are you sure you want to <br /> Approve ?</>} />
         <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
         <StatusModal
            modalId={statusModalId}
            message={confirmationMsg}
            handleClose={handleCloseStatusModal}
         />
      </>
   )
}

export default ViewFinalBill
